import styled from "styled-components";
import { color } from "../../styles";

export const PaginationWrapper = styled.div`
    width: 100%;
    height: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 24px;
    box-sizing: border-box;
    margin-top: 16px;
`;

export const TableCellHeaderContent = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;

export const CurrentPageNumberWrapper = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    height: 100%;
    font-size: 13px;
`;

export const PageListWrapper = styled.div`
    max-width: 379px;
    width: 100%;
    // height: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
`;

export const Number = styled.div`
    color: ${color.emphasis.NEUTRAL_N90};
    font-size: 16px;
    font-weight: 600;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
